import { render, staticRenderFns } from "./device_warn_page.vue?vue&type=template&id=842b160c&scoped=true"
import script from "./device_warn_page.vue?vue&type=script&lang=js"
export * from "./device_warn_page.vue?vue&type=script&lang=js"
import style0 from "./device_warn_page.vue?vue&type=style&index=0&id=842b160c&lang=scss&scoped=true"
import style1 from "./device_warn_page.vue?vue&type=style&index=1&id=842b160c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842b160c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('842b160c')) {
      api.createRecord('842b160c', component.options)
    } else {
      api.reload('842b160c', component.options)
    }
    module.hot.accept("./device_warn_page.vue?vue&type=template&id=842b160c&scoped=true", function () {
      api.rerender('842b160c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_warn_page.vue"
export default component.exports